import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { StockOrderedEvent } from './client-order-stock-controller-request.service';

@Injectable({
  providedIn: 'root'
})
export class StockOrderedEventService {
  private stockOrderedEventSubject = new Subject<StockOrderedEvent>();

  public getStockOrderedEventSubscribable(): Subject<StockOrderedEvent> {
    return this.stockOrderedEventSubject;
  }
}
